import * as React from 'react';
import {connect} from "react-redux";
import {ApplicationState} from "../../store";
import {TextField, Button, FormControl, InputLabel, Select, MenuItem} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save"
import {Tab} from '../Tab';
import {PopupDialog} from '../../core/components/PopupDialog';
import {ResponsivePie} from '@nivo/pie'
import {
	actionReportsInvoicesPaymentsFetch, actionReportsServicesFetch,
	actionReportsSetFromDate,
	actionReportsSetToDate
} from "../../store/reports";
import {Utility} from "../../core/Utility";
import DateFnsUtils from '@date-io/date-fns';
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
} from '@material-ui/pickers';
import {actionSetTabState} from "../../store/tabs/actions";
import {hr} from 'date-fns/esm/locale'
import {AppConstants} from "../../constants";
import {ServicePaymentInvoice} from "../../models/reports/ServicePaymentInvoice";
import {Formater} from "../../core/Formater";

export interface ReportServicesTabProps {
	tab: Tab
	data: ServicePaymentInvoice[],
	from: Date,
	to: Date
}

export interface ReportServicesTabState {
	isDialogOpen: boolean,
	dialogTitle: string,
	dialogText: string
}

function mapStateToProps(state: ApplicationState) {
	return {
		state: state.tabs.active.state,
		item: state.tabs.active.item,
		tab: state.tabs.active,
		data: state.reports.servicesList,
		from: state.reports.from,
		to: state.reports.to
	};
}

class ReportServicesTab extends React.Component<ReportServicesTabProps, ReportServicesTabState> {

	constructor(props: ReportServicesTabProps) {
		super(props)
		this.state = {isDialogOpen: false, dialogText: '', dialogTitle: ''}
    }

	componentDidMount() {
		actionReportsServicesFetch(AppConstants.reportDateFrom, AppConstants.reportDateTo)
	}

	onDialogClose () {
		this.setState({ ...this.state, isDialogOpen: false})
	}

	render(): React.ReactNode {
		return (
			<div style={{padding: '20px'}}>
				{this.renderFilter()}
				{this.renderForm()}
				{/*{this.renderControls()}*/}
				{this.renderPopupDialog()}
			</div>
		);
	}

	renderForm(): React.ReactNode {

		let data = []

		for (let item of this.props.data) {
			let newItem = {
				id: item.service,
				label: item.service,
				value: item.invoicesValue
			}
			data.push(newItem)
		}

		return <div style={{ height: 400 }}><ResponsivePie
			data={data}
			margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
			innerRadius={0.5}
			padAngle={0.7}
			cornerRadius={3}
			colors={{ scheme: 'nivo' }}
			borderWidth={1}
			borderColor={{ from: 'color', modifiers: [ [ 'darker', 0.2 ] ] }}
			radialLabelsSkipAngle={10}
			radialLabelsTextXOffset={6}
			radialLabelsTextColor="#333333"
			radialLabelsLinkOffset={0}
			radialLabelsLinkDiagonalLength={16}
			radialLabelsLinkHorizontalLength={24}
			radialLabelsLinkStrokeWidth={1}
			radialLabelsLinkColor={{ from: 'color' }}
			slicesLabelsSkipAngle={10}
			slicesLabelsTextColor="#333333"
			animate={true}
			motionStiffness={90}
			motionDamping={15}
			defs={[
				{
					id: 'dots',
					type: 'patternDots',
					background: 'inherit',
					color: 'rgba(255, 255, 255, 0.3)',
					size: 4,
					padding: 1,
					stagger: true
				},
				{
					id: 'lines',
					type: 'patternLines',
					background: 'inherit',
					color: 'rgba(255, 255, 255, 0.3)',
					rotation: -45,
					lineWidth: 6,
					spacing: 10
				}
			]}
			fill={[
				{
					match: {
						id: 'ruby'
					},
					id: 'dots'
				},
				{
					match: {
						id: 'c'
					},
					id: 'dots'
				},
				{
					match: {
						id: 'go'
					},
					id: 'dots'
				},
				{
					match: {
						id: 'python'
					},
					id: 'dots'
				},
				{
					match: {
						id: 'scala'
					},
					id: 'lines'
				},
				{
					match: {
						id: 'lisp'
					},
					id: 'lines'
				},
				{
					match: {
						id: 'elixir'
					},
					id: 'lines'
				},
				{
					match: {
						id: 'javascript'
					},
					id: 'lines'
				}
			]}
			legends={[
				{
					anchor: 'bottom',
					direction: 'row',
					translateY: 56,
					itemWidth: 100,
					itemHeight: 18,
					itemTextColor: '#999',
					symbolSize: 18,
					symbolShape: 'circle',
					effects: [
						{
							on: 'hover',
							style: {
								itemTextColor: '#000'
							}
						}
					]
				}
			]}
		/></div>
	}

	renderFilter(): React.ReactNode {
		return <MuiPickersUtilsProvider utils={DateFnsUtils} locale={hr}>
			<KeyboardDatePicker
				margin="normal"
				id="date-picker-dialog"
				label={"Od"}
				format={Utility.PICKER_DATE_FORMAT}
				value={this.props.from}
				onChange={(e) => {
					actionReportsSetFromDate(e)
					actionReportsServicesFetch(e, AppConstants.reportDateTo)
				}}
				onBlur={null}
				onFocus={null}
				KeyboardButtonProps={{
					'aria-label': 'change paymentDate',
				}}
				style={{marginRight: '10px'}}
			/>
			<KeyboardDatePicker
				margin="normal"
				id="date-picker-dialog"
				label={"Do"}
				format={Utility.PICKER_DATE_FORMAT}
				value={this.props.to}
				onChange={(e) => {
					actionReportsSetToDate(e)
					actionReportsServicesFetch(AppConstants.reportDateFrom, e)
				}}
				onBlur={null}
				onFocus={null}
				KeyboardButtonProps={{
					'aria-label': 'change paymentDate',
				}}
				style={{marginRight: '10px'}}
			/>
		</MuiPickersUtilsProvider>
	}

	renderControls(): React.ReactNode {
		return <div style={{display: 'flex', flexDirection:'row-reverse', marginTop: '10px'}}>
				<Button onClick={() => {}} variant="contained" color="primary" style={{}}><SaveIcon />Download</Button>
			</div>
	}

	renderPopupDialog(): React.ReactNode {
		return <PopupDialog
			isOpen={this.state.isDialogOpen}
			title={this.state.dialogTitle}
			text={this.state.dialogText}
			onClose={this.onDialogClose.bind(this)}
		/>
	}

	getFromTabState(key: string) {
		if (this.props.tab.state && this.props.tab.state[key]) return this.props.tab.state[key]
		return null
	}

	handleItemDateChange (date: Date | null, name: string) {
		let tabState = this.props.tab.state
		tabState[name] = date
		actionSetTabState(tabState)
	}
}

export default connect(mapStateToProps)(ReportServicesTab);
